module.exports = __webpack_public_path__ + "assets/img/gar8-8.0d16f2cb.jpg";